import React from "react";
import { createPortal } from "react-dom";
import "./modal.css";
import useToggleAnimatedDialog from "src/hooks/useToggle";
import { X } from "@phosphor-icons/react";
import { useEffect, useState } from "react";

const Modal = (props) => {
  const { title, children, body, bodyStyle, bodyClassName, onClose, isOpen, contentAreaStyles, closeBtnClassName } =
    props;

  const [width, setWidth] = useState(window.innerWidth);

  const [showPopup] = useToggleAnimatedDialog(isOpen, 300);
  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const responsiveStyle =
    width > 720
      ? {
          paddingLeft: "0px",
          paddingRight: "0px",
          borderRadius: "16px",
        }
      : {
          paddingLeft: "0px",
          paddingRight: "0px",
          position: "absolute",
          bottom: "0",
          borderBottomLeftRadius: "0",
          borderBottomRightRadius: "0",
        };

  const mobileClass = width <= 720 ? "modal-mobile-safe" : "";
  const mobileContentClass = width <= 720 ? "modal-content-safe" : "";
  // return null if portal element does not exist in DOM,
  // or if showPopup is false
  if (!document.getElementById("modal-portal") || !showPopup) return null;

  // use  createPortal() to render element at different location in DOM
  // even though it is written at different location in code.

  const backgroundAnimation = isOpen ? "fade-in-animation" : "fade-out-animation";
  const contentAreaAnimation = isOpen ? "zoom-in-animation" : "zoom-out-animation";

  return createPortal(
    <div
      style={{
        animationName: backgroundAnimation,
      }}
      className="popup-background"
    >
      <div
        style={{
          animationName: contentAreaAnimation,
          ...responsiveStyle,
        }}
        className={`container relative content-area w-full max-w-full ${contentAreaStyles} ${mobileClass}`}
      >
        {
          // if title is passed then only display this element
          title && <div className="flex items-center justify-between">{title}</div>
        }
        {onClose && (
          <div
            data-testid="modal-close-btn"
            className={`absolute ${
              closeBtnClassName ? closeBtnClassName : "right-10 top-4"
            } p-2 cursor-pointer z-[1000]`}
            onClick={onClose}
          >
            <X size={24} className="ml-auto" color="#949494" id="cancel-legal-review-button cursor-pointer" />
          </div>
        )}
        <div className={`h-full py-12 overflow-scroll ${bodyClassName} ${mobileContentClass}`} style={{ ...bodyStyle }}>
          {children || body}
        </div>
      </div>
    </div>,
    document.getElementById("modal-portal")
  );
};

export default Modal;
